module.exports = __webpack_public_path__ + "img/clip-frame.a311b341.png";